import { useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import Text from '../../../components/common/Text'
import { FONT_BLACK, INPUT_ERROR } from '../../../constant/colors'
import IconCoin from '../../../assets/images/icons-coin-24-px.png'
import IconEnroll from '../../../assets/images/icons-enroll.svg'
import { numberWithCommas, useRouter } from '../../../utils/helper'
import BenefitsCategory from './BenefitsCategory'
import Button from '../../../components/common/Button'
import Image from '../../../components/common/Image'
import BenefitsCategoryList from './BenefitsCategoryList'
import {
  LifeStyleBenefitsResponse,
  LifeStyleWrapperList,
  UserSelectedBenefits,
} from '../../../services/enrollment/enrollment-types'
import { useHistory } from 'react-router'
import { enrollmentWellBeing } from '../../../constant/path'

const TextNotWrap = styled(Text)`
  white-space: nowrap;
`

const FlexBetweenSpect = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

type LifeStylesProp = {
  lifeStyleBenefits: LifeStyleBenefitsResponse
  canEditable: boolean
}

const LifeStyleBenefits = (props: LifeStylesProp) => {
  const history = useHistory()
  const { query } = useRouter()

  const { lifeStyleBenefits, canEditable } = props
  const { preSelectedClaimsWrapperList, totalSelectedCoin } = lifeStyleBenefits
  const categoryName = 'สวัสดิการเพื่อไลฟ์สไตล์'
  const onClickButton = useCallback(() => {
    history.push(
      enrollmentWellBeing({
        routeParam: {
          benefitYearId: query.benefitYearId,
        },
      }),
    )
  }, [history, query.benefitYearId])

  const convertLifeStyleListToUserBenefits: UserSelectedBenefits[] = useMemo(() => {
    return preSelectedClaimsWrapperList.map((lifeStyleBenefit: LifeStyleWrapperList) => {
      const { claimId, preSelectedCredits, claimName } = lifeStyleBenefit
      return {
        id: claimId,
        selectedCoinValue: preSelectedCredits,
        categoryName: claimName,
      }
    })
  }, [preSelectedClaimsWrapperList])

  const categoriesSelfBenefits = useMemo(() => {
    return (
      <BenefitsCategory key={categoryName} icon={IconEnroll} title={categoryName}>
        <BenefitsCategoryList userSelectedList={convertLifeStyleListToUserBenefits || []}>
          {canEditable === true && <Button onClick={onClickButton}>เลือกสวัสดิการยืนหยุ่น</Button>}
        </BenefitsCategoryList>
      </BenefitsCategory>
    )
  }, [convertLifeStyleListToUserBenefits, canEditable, onClickButton])

  return (
    <>
      {categoriesSelfBenefits}
      <FlexBetweenSpect>
        <Text size={22} type={'Bold'}>
          รวมใช้คะแนน
        </Text>
        <TextNotWrap size={22} type={'Bold'} color={INPUT_ERROR} style={{ whiteSpace: 'nowrap' }}>
          <Image src={IconCoin} style={{ margin: 8 }} />-{numberWithCommas(totalSelectedCoin)}
        </TextNotWrap>
      </FlexBetweenSpect>
    </>
  )
}

export default LifeStyleBenefits
